import type { ReactNode } from 'react';
import { BrandFullLogo } from '@/components/feature/BrandLogo';

interface AuthShellProps {
  children: ReactNode;
  brandHeadline?: string;
}

export default function AuthShell({
  children,
  brandHeadline = 'شريكك في تقديم أفضل خدمة',
}: AuthShellProps) {
  return (
    <div className="flex min-h-screen w-full bg-white">
      <main className="flex flex-1 items-center justify-center px-5 py-10 sm:px-8 lg:w-[55%]">
        <div className="w-full max-w-[420px] dc-fade-up">{children}</div>
      </main>

      <aside className="relative hidden overflow-hidden bg-primary-700 lg:flex lg:w-[45%] lg:flex-col lg:items-center lg:justify-center">
        <div className="absolute inset-0 bg-gradient-to-br from-primary-600 via-primary-700 to-primary-900"></div>
        <div
          className="absolute -left-24 -top-24 h-72 w-72 rounded-full bg-secondary-500/25 blur-3xl"
          aria-hidden="true"
        ></div>
        <div
          className="absolute -bottom-28 -right-16 h-80 w-80 rounded-full bg-accent-500/20 blur-3xl"
          aria-hidden="true"
        ></div>

        <div className="relative z-10 flex w-full max-w-[380px] flex-col items-center px-10 text-center">
          <BrandFullLogo className="h-24 brightness-0 invert" />
          <p className="mt-4 text-base text-secondary-200">{brandHeadline}</p>

          <div className="mt-10 flex w-full items-center justify-center gap-6 text-secondary-200">
            <span className="flex items-center gap-2 text-[13px]">
              <i className="ri-truck-line text-lg" aria-hidden="true"></i>
              استلام وتسليم
            </span>
            <span className="flex items-center gap-2 text-[13px]">
              <i className="ri-timer-flash-line text-lg" aria-hidden="true"></i>
              تنفيذ مستعجل
            </span>
            <span className="flex items-center gap-2 text-[13px]">
              <i className="ri-shield-check-line text-lg" aria-hidden="true"></i>
              جودة مضمونة
            </span>
          </div>
        </div>
      </aside>
    </div>
  );
}